import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/canny/sso-token']['GET'];

const getCannyToken = async (): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.get('/canny/sso-token');
  return response.data;
};

export default getCannyToken;
